import { useMutation } from "@tanstack/react-query";
import log from "loglevel";

import { sdkLogins, VkLoginPayload } from "../lib/sdk";
import { LoginProvider } from "../lib/types";

/**
 * @interface LoginParams
 * @description Параметры для функции мутации входа.
 */
interface LoginParams {
	provider: LoginProvider;
	email?: string;
	captchaToken?: string;
	gameSystemName?: string;
	vkPayload?: VkLoginPayload; // Добавляем параметры для VK
}

async function loginMutationFn({ provider, email, captchaToken, gameSystemName, vkPayload }: LoginParams) {
	log.debug(`Login mutation started with provider: ${provider}`);

	if (provider === "email") {
		if (!email) throw new Error("Email is required for email login");
		if (!captchaToken) throw new Error("Captcha token is required for email login");
		return sdkLogins.email(email, captchaToken, gameSystemName);
	}

	if (provider === "vk") {
		if (!vkPayload) throw new Error("VK payload is required for VK login");
		return sdkLogins.vk(vkPayload, gameSystemName);
	}

	// Для социальных логинов (Google, Apple, Facebook)
	const socialLoginFn = sdkLogins[provider];
	if (!socialLoginFn) {
		log.error(`No login function found for provider: ${provider}`);
		throw new Error(`Login provider ${provider} is not supported.`);
	}
	return socialLoginFn(gameSystemName);
}

/**
 * Хук для выполнения мутации входа.
 * Обрабатывает логику входа через различных провайдеров.
 * @returns {object} Мутация useMutation от react-query.
 */
export const useLoginMutation = () => {
	return useMutation({
		mutationKey: ["auth", "authV2"],
		mutationFn: loginMutationFn
	});
};
